import { useCallback } from 'react';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface UnDeleteReceiptRequest {
  receiptIds?: any[];
}

const useUnDeleteReceiptsApi = () => {
  const call = useCallback(async ({ receiptIds }: UnDeleteReceiptRequest = {}) => {
    try {
      const res = await axiosInstance.post(`/Receipt/UnDelete`, receiptIds);
      return res;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute } = useAsync(call, false);

  return { unDeleteReceipts: execute, unDeleteReceiptLoading: isLoading };
};

export default useUnDeleteReceiptsApi;
